import React from 'react';

export interface ActualizarIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const ActualizarIcon: React.FC<ActualizarIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M23.958 4.877v6.25m0 0h-6.25m6.25 0-4.833-4.542a9.375 9.375 0 0 0-15.469 3.5M1.042 21.544v-6.25m0 0h6.25m-6.25 0 4.833 4.541a9.375 9.375 0 0 0 15.469-3.5"/>
    </svg>
  );
};

export default ActualizarIcon;
